import { useMemo } from 'react';

import { buildLauncherGridItems, isLinkVisible } from '../nav-link-utils';

export const useLauncherLinks = ({ links, role, roleProps, isLimitedAccount }) => {
    const visibilityProps = useMemo(() => ({ ...roleProps, ...role }), [roleProps, role]);

    const visibleLinks = useMemo(() => links.filter(link => isLinkVisible(link, visibilityProps)), [
        links,
        visibilityProps
    ]);

    const gridItems = useMemo(() => buildLauncherGridItems(visibleLinks, isLimitedAccount), [
        visibleLinks,
        isLimitedAccount
    ]);

    return { visibleLinks, gridItems };
};
